/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum PartNumberChangesColumnEnum {
    TYPE = 'TYPE',
    NUMBER = 'NUMBER',
    CREATION_DATETIME = 'CREATION_DATETIME',
    PARTNER = 'PARTNER',
    UPDATED_BY = 'UPDATED_BY',
    CHANGED_ON = 'CHANGED_ON',
    OLD_MATERIAL_NUMBER = 'OLD_MATERIAL_NUMBER',
    STATUS = 'STATUS',
    TECHNICIAN_GROUP = 'TECHNICIAN_GROUP',
    NEW_PART_NUMBER = 'NEW_MATERIAL_NUMBER',
    CREATED_BY = 'CREATED_BY',
    SUPPLYING_PACKING_PLANT = 'SUPPLYING_PACKING_PLANT',
    DONE = 'DONE',
}
